export default __webpack_public_path__ + "static/media/sos-dia-03-11.0ec532f6.webp";